import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ContractActivation } from './ContractActivation';

interface AccessDeniedProps {
  onLogout: () => void;
  reason?: 'atlas_access_denied' | 'atlas_user_missing' | 'atlas_user_baja';
  onRegister?: (contractCode: string) => Promise<void>;
}

export function AccessDenied({ onLogout, reason, onRegister }: AccessDeniedProps) {
  if (reason === 'atlas_user_missing') {
    return <ContractActivation onLogout={onLogout} onRegister={onRegister} />;
  }
  return (
    <Box
      component="main"
      role="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        padding: 3,
        textAlign: 'center',
        color: 'text.primary',
        backgroundColor: 'background.default',
      }}
    >
      <Typography component="h1" variant="h5">
        No tienes permisos para acceder
      </Typography>
      <Typography sx={{ maxWidth: 640 }} color="text.secondary">
        {reason === 'atlas_user_baja'
            ? 'Tu usuario está de baja. Contacta con un administrador si necesitas acceso.'
            : 'Tu usuario no tiene permisos para acceder a este cliente. Contacta con un administrador si necesitas acceso.'}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={onLogout}
      >
        Cerrar sesión
      </Button>
    </Box>
  );
}

export default AccessDenied;
